import { jsx as _jsx } from "react/jsx-runtime";
import RangeDatePicker from "./components/RangeDatePicker";
import SingleDatePicker from "./components/SingleDatePicker";
const DatePicker = (props) => {
    if (props.mode === "single") {
        return _jsx(SingleDatePicker, { ...props });
    }
    return _jsx(RangeDatePicker, { ...props });
};
export default DatePicker;
